import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAPIResponse } from '../enums/types';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { environment } from "../../environments/environment";
import { EModelApiPaths } from '../enums/EModelApiPaths';

@Injectable({
  providedIn: 'root'
})
export class LoadBrands extends BaseService {
  constructor(public override http: HttpClient,
    public override utilsService: UtilsService,
    public override userService: UserService) {
    super(http, userService, utilsService, `${EModelApiPaths.CUSTOM_API_BASE}/${environment.USER_PATH}${EModelApiPaths.LOAD_BRANDS}`);
  }

  async loadBrands<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.LOAD_BRANDS, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }
}
